module.exports = __webpack_public_path__ + "images/skewness-03-desktop.png";